import { httpClient } from '@/shared/infrastructure/http-client';
import { generateUUID } from '@/utilities/uuid/generate-uuid';
import type { TrackEventInput, TrackEventPayload, TrackingContextValue, TrackingServiceConfig } from './tracking.types';

class TrackingService {
  private config: TrackingServiceConfig | null = null;
  // private _config: TrackingServiceConfig | null = null;
  // private get config(): TrackingServiceConfig {
  // 	if (!this._config) {
  // 		throw new Error("Tracking session not initialized");
  // 	}
  // 	return this._config;
  // }
  private initialized = false;
  init(config: TrackingServiceConfig) {
    if (this.initialized) {
      console.warn('[TrackingService] Already initialized', this.config);
      return;
    }
    this.config = {
      enabled: true,
      ...config,
    };
    this.initialized = true;

    if (import.meta.env.MODE === 'development') {
      console.info('[Traking] Inicializado', {
        endpoint: this.config.endpoint,
        enabled: this.config.enabled,
      });
    }
  }
  send(input: TrackEventInput, ctx: Omit<TrackingContextValue, 'setCorrelationId'>) {
    if (!this.config) {
      console.warn('[TrackingService] Llama a init() antes de usar track().');
      return;
    }

    if (!this.config.enabled) {
      if (import.meta.env.MODE === 'development') {
        console.debug('[TrackingService Disabled] event skipped:', input.action);
      }
      return;
    }

    const payload = this.buildPayload(input, ctx);

    if (import.meta.env.MODE === 'development') {
      console.debug('[Tracking] ->', payload.action, payload);
    }

    this.post(payload).catch((err) => {
      console.error('[Tracking] Error al enviar evento', err);
    });
  }

  private async post(payload: TrackEventPayload) {
    if (!this.config) {
      throw new Error('Tracking session not initialized');
    }
    await httpClient.post(this.config.endpoint, payload);
    console.log(payload);
  }

  private buildPayload(input: TrackEventInput, ctx: TrackingContextValue): TrackEventPayload {
    if (!this.config) {
      throw new Error('Tracking session not initialized');
    }
    return {
      eventId: generateUUID(),
      category: input.category,
      action: input.action,
      trigger: input.trigger,

      module: ctx.module,
      screen: ctx.screen,

      projectId: input.projectId ?? ctx.projectId,
      projectName: input.projectName ?? ctx.projectName,
      contentType: 'video',

      metadata: input.metadata ?? {},
      clientTimestamp: new Date().toISOString(),
    };
  }
}

export const trackingService = new TrackingService();
